// src/components/ForgotPasswordLink.js
import React from 'react';

const ForgotPasswordLink = () => {
  return (
    <div className="forgot-password">
      <a href="#">Forgot your password?</a>
    </div>
  );
};

export default ForgotPasswordLink;